import configData from './config.json'

const baseurl= configData.BASE_URL
const resulturl = configData.RESULT_URL
const eventid= configData.EVENT_ID

export const getEvent =  () => {
    return fetch(baseurl+'/events/PC'+eventid+ '/races') 
      . then (data=>data.json())
      . then (data=>data.races)
}

export const getRace = (raceid) => {
    return fetch(baseurl+'/events/PC'+eventid+ '/races/'+ raceid) 
      .then(data => data.json())
      .then(data => appendPlayerLink(data,raceid))
}

export const getPlannedRaces = () => {
    return fetch(baseurl+'/events/PC'+eventid+ '/races') 
      . then (data=>data.json())
      . then (data=>Filter(data.event,data.races, 0))
}


export const getCompletedRaces = () => {
    return fetch(baseurl+'/events/PC'+eventid+ '/races') 
      . then (data=>data.json())
      . then (data=>Filter(data.event, data.races, 1))
      
}

const Filter = (event, races, guntimeFilter) => {
  let f_races=[];
  if (guntimeFilter === 0) {
  // We need planned races with no chipTime
    f_races = races.filter(item => ( item.classificationsCount > 0 && item.classifications[0].chipTime === '0.000'))
    f_races.sort((a, b) => a.date.localeCompare(b.date));
  }
  else {
  // We need completed races with chipTime not 0.000
    f_races = races.filter(item => ( item.classificationsCount > 0 && item.classifications[0].chipTime !== '0.000'))
    f_races.sort((a, b) => b.date.localeCompare(a.date));
  }
  let f1_races = f_races.map( r => ( {id:r.id, name: r.name, classifications:[]}));
  f1_races = f1_races.filter(item => (!item.name.includes("#hide")))
  return ({'event': event, 'races':f1_races})
}

const appendPlayerLink = (racedata,raceid) => {
  // prochipRaceType == 4 is merges. Merges on Mylaps has no futher info
  if (racedata.race.prochipRaceType != 4){
    racedata.race.classifications.map( c => { c.playerlink = resulturl + "/sessions/" + raceid + "/laptimes?pos=" + c.rank })
    racedata.race.mylapslink = resulturl + "/sessions/" + raceid  
  }
  return racedata
}